// translate-config.module.ts
import { NgModule } from '@angular/core';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { CustomTranslateLoader } from './custom-translate-loader';
import { CustomMissingTranslationHandler } from './custom-missing-translation-handler';

@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: CustomMissingTranslationHandler
      }
    })
  ],
  exports: [TranslateModule]
})
export class TranslateConfigModule { }